import React from "react";
import "./snackbar.scss";
import Snackbar from "@mui/material/Snackbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faCircleCheck } from "@fortawesome/free-solid-svg-icons";

interface SnackbarProps {
    open: boolean;
    message: string;
    severity: "success" | "error";
    duration: number;
    onClose: () => void;
}

const CustomSnackbar: React.FC<SnackbarProps> = ({ open, message, severity, duration, onClose }) => {
    return (
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={open}
            autoHideDuration={duration}
            onClose={onClose}
        >
            <div className="snackbar">
                {severity === "success" ? (
                    <>
                        <FontAwesomeIcon icon={faCircleCheck} className="icon-complete" />
                        <span className="ms-2">{message}</span>
                    </>
                ) : (
                    <>
                        <FontAwesomeIcon icon={faCircleExclamation} className="icon-warning" />
                        <span className="ms-2">
                            {message || 'เกิดข้อผิดพลาดบางประการ กรุณาลองอีกครั้ง'}
                        </span>
                    </>
                )}
            </div>
        </Snackbar>
    );
};

export default CustomSnackbar;
